import * as React from 'react';
import { PopoverProps } from './Popover.types';
import { StyledPopover } from './Popover.style';

export function Popover(props: PopoverProps) {
  const { children, anchorEl, large = false, onClose } = props;
  return React.useMemo(() => {
    const open = Boolean(anchorEl);
    const anchorOrigin: any = {
      vertical: 'bottom',
      horizontal: 'left',
    };
    const transformOrigin: any = {
      vertical: 'top',
      horizontal: 'left',
    }
    const classes = {
      paper: 'hierarchy-popover-paper',
    }
    return (
      <StyledPopover
        open={open}
        anchorEl={anchorEl}
        large={large.toString()}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        onClose={onClose}
        classes={classes}
      >
        {children}
      </StyledPopover>
    )
  }, [large, anchorEl, children]);
}